// src/components/account/AccountSettingsModal.js
import React, { useState, useEffect } from 'react';
import { useAuth } from '../../firebase/AuthContext';
import InputField from '../ui/InputField';
import Modal from '../ui/Modal';

const AccountSettingsModal = ({ isOpen, onClose }) => {
  const { currentUser } = useAuth();
  const [displayName, setDisplayName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // Initialize form fields from current user
  useEffect(() => {
    if (currentUser && isOpen) {
      setDisplayName(currentUser.displayName || '');
    }
  }, [currentUser, isOpen]);

  const handleSaveProfile = async (e) => {
    e.preventDefault();
    try {
      setError('');
      setSuccess('');
      setLoading(true);

      // In a real app, update the user's profile using updateProfile()
      // For now, this is a placeholder
      console.log('Would update profile:', { displayName });

      setSuccess('Profile updated successfully');
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError(err.message || 'Failed to update profile');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Account Settings"
      width="320px"
      height="auto"
    >
      {/* Success/Error Messages */}
      {error && (
        <div className="mb-app-xl p-app-lg bg-app-red-50 border border-app-red-200 rounded-app-lg">
          <p className="text-app-sm text-app-red-700">{error}</p>
        </div>
      )}
      {success && (
        <div className="mb-app-xl p-app-lg bg-app-green-50 border border-app-green-200 rounded-app-lg">
          <p className="text-app-sm text-app-green-700">{success}</p>
        </div>
      )}

      {/* Profile Section */}
      <div className="mb-app-2xl">
        <h3 className="text-app-md font-semibold text-app-gray-900 mb-app-lg">Profile Information</h3>
        
        <form onSubmit={handleSaveProfile} className="space-y-app-xl">
          <InputField
            id="email"
            label="Email"
            type="email"
            value={currentUser?.email || ''}
            disabled
            helperText="Email cannot be changed"
          />

          <InputField
            id="displayName"
            label="Display Name"
            type="text"
            value={displayName}
            onChange={(e) => setDisplayName(e.target.value)}
            placeholder="Enter your name"
            disabled={loading}
          />
          <div className="flex justify-end">
            <button
              type="submit"
              className="btn-primary disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={loading}
            >
              {loading ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default AccountSettingsModal;